import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { Calendar as CalendarIcon } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { cn } from '@/lib/utils';

interface FilterDateRangeProps {
  label: string;
  from?: Date;
  to?: Date;
  onFromChange: (date?: Date) => void;
  onToChange: (date?: Date) => void;
  className?: string;
}

/**
 * Универсальный компонент фильтра диапазона дат для использования в TableToolbar
 */
export function FilterDateRange({
  label,
  from,
  to,
  onFromChange,
  onToChange,
  className,
}: FilterDateRangeProps) {
  const formatDate = (date?: Date) => {
    if (!date) {return 'Выберите дату';}
    return format(date, 'd MMM yyyy', { locale: ru });
  };

  return (
    <div className={className}>
      <Label className="text-sm font-medium">{label}</Label>
      <div className="flex gap-2 mt-1.5">
        <Popover>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              className={cn(
                'flex-1 justify-start text-left font-normal',
                !from && 'text-muted-foreground'
              )}
            >
              <CalendarIcon className="mr-2 h-4 w-4" />
              {formatDate(from)}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start">
            <Calendar
              mode="single"
              selected={from}
              onSelect={onFromChange}
              locale={ru}
              initialFocus
            />
          </PopoverContent>
        </Popover>

        <span className="flex items-center text-muted-foreground">—</span>

        <Popover>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              className={cn(
                'flex-1 justify-start text-left font-normal',
                !to && 'text-muted-foreground'
              )}
            >
              <CalendarIcon className="mr-2 h-4 w-4" />
              {formatDate(to)}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start">
            <Calendar
              mode="single"
              selected={to}
              onSelect={onToChange}
              locale={ru}
              initialFocus
              disabled={(date) => (from ? date < from : false)}
            />
          </PopoverContent>
        </Popover>
      </div>
    </div>
  );
}
